import { useEffect } from "react";

import { ReactComponent as ErrorIcon } from "./clock-time.svg";

import SiteWrapper from "../../SiteWrapper";

import styles from "./styles.module.scss";
import Column from "../../Column";
import RoundButton from "../../RoundButton";
import t from "../../../utils/translate";
/**
 *
 * @param {object} param0
 * @param {[function]} param0.onClick
 * @returns
 */
const Error = ({ onClick, error }) => {
  useEffect(() => {
    if (error) {
      console.error(error);
      window.newrelic?.noticeError(error);
    }
  }, [error]);

  return (
    <div className={styles.ctn}>
      <SiteWrapper size="small">
        <div className={styles.error}>
          <div className={styles.icon}>
            <ErrorIcon />
          </div>
          <Column>
            <p className={styles.description}>{t("CLINIC_CHECKOUT_ERROR")}</p>
            {onClick && (
              <RoundButton onClick={onClick}>{t("RETRY")}</RoundButton>
            )}
          </Column>
        </div>
      </SiteWrapper>
    </div>
  );
};

export default Error;
